import React from "react";
import { Layout, Menu } from "antd";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import {
  DashboardOutlined,
  RocketOutlined,
  LogoutOutlined,
  UserOutlined,
  SettingOutlined,
  AppstoreOutlined
} from "@ant-design/icons";
import { GlobalContext } from "../../context.global";
import { injectIntl, IntlShape } from "react-intl";
import SelectLanguage from "../SelectLanguage";
import UserAvatar from "../UserAvatar";
import "./styles.css";

const { Header } = Layout;
const { SubMenu } = Menu;

interface ICustomHeaderProps {
  history: any;
  intl: IntlShape;
}

interface ICustomHeaderState {}

class CustomHeader extends React.Component<ICustomHeaderProps, ICustomHeaderState> {
  static contextType = GlobalContext;
  context!: React.ContextType<typeof GlobalContext>;

  handleSignOut = async () => {
    localStorage.removeItem("KetricsApplicationsRefreshToken");
    await Auth.signOut();
  };

  goTo = (path: string) => {
    this.props.history.push(path);
  };

  render() {
    return (
      <Header className="Header" style={{ height: 48, lineHeight: "48px" }}>
        <div className="logo">
          <Link to="/">
            <img src="/logo-ketrics.png" alt="" height="30" />
          </Link>
        </div>

        <div style={{ paddingTop: 3 }}>
          <Menu
            mode="horizontal"
            style={{ lineHeight: "42px", float: "left" }}
            className="header-left-menu"
            defaultSelectedKeys={[]}
            defaultOpenKeys={[]}
            selectedKeys={[]}
          >
            <SubMenu
              key="applications"
              title={this.props.intl.formatMessage({
                id: "applications",
                defaultMessage: "Applications"
              })}
              onTitleClick={() => this.goTo("/applications")}
              icon={<AppstoreOutlined />}
            >
              {this.context.applicationsGroups.map((group, groupIndex) => {
                return (
                  <SubMenu key={groupIndex} title={group.group}>
                    {group.applications.map((application, applicationIndex) => {
                      return (
                        <Menu.Item
                          key={applicationIndex}
                          onClick={() => this.goTo(`/applications/${application.applicationId}`)}
                          icon={
                            application.type === "dashboard" ? (
                              <DashboardOutlined />
                            ) : (
                              <RocketOutlined />
                            )
                          }
                        >
                          {application.label}
                        </Menu.Item>
                      );
                    })}
                  </SubMenu>
                );
              })}
            </SubMenu>
          </Menu>

          <Menu selectedKeys={[]} mode="horizontal" style={{ lineHeight: "42px", float: "right" }}>
            <SubMenu
              key="UserMenu"
              title={
                <span className="submenu-title-wrapper">
                  <span style={{ marginRight: 5 }}>{this.context.user.email}</span>
                  <UserAvatar user={this.context.user} size={24} />
                </span>
              }
              style={{ margin: 0 }}
            >
              <Menu.Item key="userSettings" onClick={() => this.goTo("/user/settings")}>
                <UserOutlined />
                {this.props.intl.formatMessage({
                  id: "userSettings",
                  defaultMessage: "User Settings"
                })}
              </Menu.Item>

              {this.context.user.isAccountAdmin && [
                <Menu.Divider key="div1" />,
                <Menu.Item key="settings" onClick={() => this.goTo("/account/settings")}>
                  <SettingOutlined />
                  {this.props.intl.formatMessage({
                    id: "account.settings"
                  })}
                </Menu.Item>
              ]}

              <Menu.Divider />

              <Menu.Item key="1" onClick={this.handleSignOut}>
                <LogoutOutlined />
                {this.props.intl.formatMessage({
                  id: "login.signOut",
                  defaultMessage: "Sign Out"
                })}
              </Menu.Item>
            </SubMenu>

            <SelectLanguage style={{ marginLeft: 10 }} />
          </Menu>
        </div>
      </Header>
    );
  }
}

export default injectIntl(CustomHeader);
